/**
 * Web3 Service
 * @author Dmitry Filyaev aka Fima
 */

import Web3 from 'web3';
import ABI from './abi.json';
// import store from '../store.jsx';
// import { logoutPlayer } from '../redux/actions/authActions';

class Web3Service {
  // Create Singleton in constructor
  constructor() {
    if (!Web3Service.instance) {
      //
      // const web3 = new Web3(new Web3.providers.HttpProvider(`https://${process.env.INFURA_NETWORK}.infura.io/v3/${process.env.INFURA_API}`));
      const web3 = new Web3(
        new Web3.providers.HttpProvider('https://rpc-amoy.polygon.technology')
      );
      // Create contract instance
      this.contract = new web3.eth.Contract(ABI, process.env.CONTRACT_ADDRESS);
      //
      this.web3 = web3;
      Web3Service.instance = this;
    }
    return Web3Service.instance;
  }

  async connect() {
    return new Promise((resolve, reject) => {
      //
      if (
        typeof window.ethereum === 'undefined' ||
        typeof window.web3 === 'undefined'
      ) {
        reject(new Error('WEB3_ERR:ERR_NO_METAMASK'));
      }
      //
      const { ethereum } = window;
      //
      if (ethereum) {
        //
        const web3 = new Web3(ethereum);
        //
        ethereum.autoRefreshOnNetworkChange = false;
        //
        ethereum
          .enable()
          //
          .then(async (accounts) => {
            //
            const network = await this.web3.eth.net.getId();
            //
            if (network !== parseInt(process.env.NETWORK_ID, 10)) {
              reject(new Error('WEB3_ERR:WRONG_NETWORK'));
            }
            //
            [this.publicAddress] = accounts;
            //
            this.web3 = web3;
            // Create contract instance
            this.contract = new web3.eth.Contract(
              ABI,
              process.env.CONTRACT_ADDRESS
            );
            //
            resolve(this.publicAddress);
          })
          .catch((err) => {
            if (err) {
              // Emit new error if account is locked
              reject(new Error('WEB3_ERR:ACCOUNT_LOCKED'));
            }
          });
      } else if (window.web3) {
        // Legacy dapp browsers
        const web3 = new Web3(window.web3.currentProvider);
        resolve(web3.defaultAccount);
      }
    });
  }

  /**
   * Balance
   */
  async contractBalance() {
    //
    return this.web3.eth
      .getBalance(process.env.CONTRACT_ADDRESS)
      .then((result) => this.web3.utils.fromWei(result, 'ether'))
      .catch((err) => {
        throw new Error(err.message);
      });
  }

  /**
   * Retrive Player balance
   */
  async balance(address) {
    //
    return this.web3.eth
      .getBalance(address)
      .then((result) => `${this.web3.utils.fromWei(result, 'ether')} POL`)
      .catch((err) => {
        throw new Error(err.message);
      });
  }

  /**
   * Convert Vei to ETH
   */
  convert(value) {
    //
    return `${this.web3.utils.fromWei(value, 'ether')} POL`;
  }

  /**
   * Fees
   */
  async estimateFees() {
    if (!this.contract) {
      console.warn('Contract not initialized');
      return 0;
    }
    if (!this.publicAddress) {
      console.warn('Public address not set - cannot call estimateFees without wallet connection');
      return 0;
    }
    try {
      const result = await this.contract.methods
        .viewFeesBalance()
        .call({ from: this.publicAddress });
      return this.web3.utils.fromWei(result, 'ether');
    } catch (err) {
      console.error('Error estimating fees:', err.message);
      console.warn('Note: Contract method viewFeesBalance() may not exist or contract call failed');
      return 0;
    }
  }

  /**
   * Is Owner
   */
  async isOwner() {
    if (!this.publicAddress) {
      console.warn('Public address not set - cannot check owner');
      return false;
    }
    try {
      return await this.contract.methods
        .isOwner()
        .call({ from: this.publicAddress });
    } catch (err) {
      console.error('Error checking if owner:', err.message);
      return false;
    }
  }

  /**
   * Owner
   */
  async fetchOwner() {
    if (!this.publicAddress) {
      console.warn('Public address not set - cannot fetch owner');
      return null;
    }
    try {
      return await this.contract.methods
        .owner()
        .call({ from: this.publicAddress });
    } catch (err) {
      console.error('Error fetching owner:', err.message);
      return null;
    }
  }

  async withdrawFees() {
    return new Promise(async (resolve, reject) => {
      if (!this.publicAddress) {
        reject(new Error('WEB3_ERR:WALLET'));
        return;
      }
      if (!this.contract) {
        reject(new Error('WEB3_ERR:CONTRACT_NOT_INITIALIZED'));
        return;
      }
      try {
        const gasLimit = await this.contract.methods
          .withdrawFees()
          .estimateGas({ from: this.publicAddress });
        // Try to Call the contract method
        await this.contract.methods
          .withdrawFees()
          .send({
            from: this.publicAddress,
            gasPrice: this.web3.utils.toWei('21', 'gwei'),
            gasLimit,
          })
          .on('transactionHash', (hash) => {
            resolve(hash);
          })
          .catch((err) => {
            reject(err);
          });
      } catch (err) {
        reject(err);
      }
    });
  }

  // /**
  //  * @dev Call after service will created
  //  * Connect to Metamask
  //  */
  // connect() {
  //   return new Promise((resolve, reject) => {
  //     // Check ethereum or web3
  //     if (typeof window.ethereum === 'undefined' || (typeof window.web3 === 'undefined')) {
  //       reject(new Error('WEB3_ERR:ERR_NO_METAMASK'));
  //     }
  //     // Destructing ethereum from window
  //     const { ethereum } = window;
  //     // After 2nd November
  //     if (ethereum) {
  //       // Create Web3 Instance
  //       const web3 = new Web3(ethereum);
  //       //
  //       ethereum.autoRefreshOnNetworkChange = false;
  //       // Connect Metamask to Cryptower Game
  //       ethereum.enable()
  //         // Unlock player's account
  //         .then(async (accounts) => {
  //           // Assign web3 instance to class var
  //           this.web3 = web3;
  //           // Fetch network
  //           const network = await this.web3.eth.net.getId();
  //           if (network !== 3) {
  //             reject(new Error('WEB3_ERR:WRONG_NETWORK'));
  //           }
  //           // Destructing account from accounts
  //           [this.publicAddress] = accounts;
  //           // Convert
  //           this.publicAddress = this.publicAddress.toLowerCase();
  //           // Create contract instance
  //           this.contract = new web3.eth.Contract(ABI, CONTRACT_ADDRESS);
  //           // Init listeners
  //           this.attachListeners();
  //           // Resolve promise
  //           resolve(this.publicAddress);
  //         })
  //         .catch((e) => {
  //           if (e) {
  //             // Emit new error if account is locked
  //             reject(new Error('WEB3_ERR:ACCOUNT_LOCKED'));
  //           }
  //         });
  //     } else if (window.web3) {
  //       // Legacy dapp browsers
  //       const web3 = new Web3(window.web3.currentProvider);
  //       resolve(web3.defaultAccount);
  //     }
  //   });
  // }

  // // Listeners
  // attachListeners() {
  //   window.ethereum.on('accountsChanged', (accounts) => {
  //     // console.log('account changed!', accounts[0]);
  //     // Time to reload your interface with accounts[0]!
  //     store.dispatch(logoutPlayer());
  //   });
  //   window.ethereum.on('networkChanged', (netId) => {
  //     // Time to reload your interface with netId
  //     // console.log('Network changed!', netId);
  //     store.dispatch(logoutPlayer());
  //   });
  // }

  // // Get player's network
  // fetchNetwork() {
  //   return new Promise((resolve, reject) => {
  //     if (this.web3) {
  //       this.web3.eth.net.getId()
  //         .then(resolve)
  //         .catch(reject);
  //     }
  //     reject(new Error('WEB3_ERR:FETCH_NETWORK'));
  //   });
  // }
}

const instance = new Web3Service();

export default instance;
